import React from 'react';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';

function AddSegmentRow({ onClick, onToggleSegmentationVisibility = null, segmentation = null }) {
  const { t } = useTranslation('SegmentationTable');
  return (
    <div className="flex justify-between bg-white pl-[34px] hover:cursor-pointer">
      <div
        className="group py-[5px] pb-[5px] ml-[30px]"
        onClick={onClick}
      >
        <div className="text-primary-active flex items-center rounded-[4px] pr-2 group-hover:bg-[#d9d9d9]">
          <div className="grid h-[28px] w-[28px] place-items-center">
            <Icon name="icon-add" />
          </div>
          <span className="text-[13px] font-bold text-black">{t('Add segment')}</span>
        </div>
      </div>
      {segmentation && (
        <div className="flex items-center">
          <div
            className="ml-3 mr-1 grid h-[28px] w-[28px]  cursor-pointer place-items-center rounded-[4px] hover:bg-[#d9d9d9]"
            onClick={() => onToggleSegmentationVisibility(segmentation.id)}
          >
            {segmentation.isVisible ? (
              <Icon
                name="row-shown"
                className="text-primary-active"
              />
            ) : (
              <Icon
                name="row-hidden"
                className="text-primary-active"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AddSegmentRow;
